import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';

const transaction_status_url =
  'http://localhost:3000/verify-payment/ORDERID_99911';

export const fetchTransactionStatus = async (
  checksum: string,
): Promise<any> => {
  try {
    //const req = JSON.stringify(parameters.payload);
    const response = await httpClient.post(
      `${transaction_status_url}`,
      {checksum},
      {
        headers: {
          ...DEFAULT_HEADERS,
          // Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    //TODO: uncomment later
    //return response.data;
    //TODO: remove later
    return response; // mockCouponResponse;
  } catch (error) {
    throw new APIError(error);
  }
};

type TxnTokenRequest = {
  orderId: string;
  amount: string;
  customerId: string;
};

const transaction_token_url = 'http://localhost:3000/request-token';
export const fetchTransactionToken = async (
  payload: TxnTokenRequest,
): Promise<any> => {
  try {
    //const req = JSON.stringify(parameters.payload);
    const response = await httpClient.post(
      `${transaction_token_url}`,
      {payload},
      {
        headers: {
          ...DEFAULT_HEADERS,
          // Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    throw new APIError(error);
  }
};
